import React from 'react';
import TeammateCard from './TeammateCard';

// NOTE: We need a proper TeammateState definition
interface TeammateState {
  _id: string;
  nickname: string;
  toolsExperience: { tool: string; mep: number }[];
  areaOfExpertise: string[];
  productType: string[];
  projectType: string[];
  offeredGratification: string[];
  forGratification: string[];
  baseLocation: string[];
}

const TeammateBox = ({
  teammate,
  tokenAvailable,
  addTeammate,
  deleteTeammate,
  teammateAdded,
  loading,
  myTeammate = false
}: {
  teammate: TeammateState;
  tokenAvailable: boolean;
  addTeammate?: () => Promise<void>;
  deleteTeammate?: () => Promise<void>;
  teammateAdded?: boolean;
  loading?: boolean;
  myTeammate?: boolean;
}) => {
  if (loading) {
    return <TeammateCard teammate={{} as TeammateState} loading={true} tokenAvailable={false} />;
  }

  return (
    <TeammateCard
      teammate={teammate}
      tokenAvailable={tokenAvailable}
      addTeammate={addTeammate}
      deleteTeammate={deleteTeammate}
      teammateAdded={teammateAdded}
      myTeammate={myTeammate}
    />
  );
};

export default TeammateBox;
